function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M61.769 24.1427L50.9182 16.4011L39.6566 23.8503L50.7098 31.6143L61.769 24.1427Z",
  fill: "#0897FE"
});

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  className: "path-2"
}, React.createElement("path", {
  d: "M55.7069 0.219971L55.5441 12.3666L69.2868 22.1554L78.1023 16.2087L55.7069 0.219971Z",
  fill: "#0D2CCC"
}), React.createElement("path", {
  d: "M55.2327 35.6304L55.0699 47.7801L79.6657 31.2248L79.8285 19.0764L55.2327 35.6304Z",
  fill: "#0D2CCC"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  className: "path-1"
}, React.createElement("path", {
  d: "M44.2932 0.219971L44.456 12.3666L30.7133 22.1554L21.8978 16.2087L44.2932 0.219971Z",
  fill: "#0D2CCC"
}), React.createElement("path", {
  d: "M44.7673 35.6304L44.9301 47.7801L20.3343 31.2248L20.1715 19.0764L44.7673 35.6304Z",
  fill: "#0D2CCC"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.5,
  className: "path-2"
}, React.createElement("path", {
  opacity: 0.5,
  d: "M80.4134 2.10547L80.2903 11.3389L95.336 22.0559L102.057 17.5217L80.4134 2.10547Z",
  fill: "#0D2CCC"
}), React.createElement("path", {
  opacity: 0.5,
  d: "M102.914 21.3521L79.9487 36.8092L79.8285 45.7898L102.914 30.2522V21.3521Z",
  fill: "#0D2CCC"
}));

var _ref6 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.5,
  className: "path-1"
}, React.createElement("path", {
  opacity: 0.5,
  d: "M19.5866 2.10547L19.7098 11.3389L4.66407 22.0559L-2.05691 17.5217L19.5866 2.10547Z",
  fill: "#0D2CCC"
}), React.createElement("path", {
  opacity: 0.5,
  d: "M-2.91412 21.3521L20.0513 36.8092L20.1715 45.7898L-2.91412 30.2522V21.3521Z",
  fill: "#0D2CCC"
}));

var SvgBroadcastIcon = function SvgBroadcastIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBroadcastIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/BroadcastIcon.4899f470.svg";
export { ForwardRef as ReactComponent };